import {getRole,getSurveyRole, get_Attention,get_GuidePage,get_SurveyType,getShareSurvey } from '../utils/cache'

const state = {
  surveyRole: getSurveyRole(),
  role: getRole(),
  attention: get_Attention(),
  guidePage: get_GuidePage(),
  surveyType: get_SurveyType(),
  shareSurvey:getShareSurvey(),
  userInfo:null,
}

export default state



// WEBPACK FOOTER //
// ./src/store/state.js